import MeasureType from './MeasureType'
import MetricCategoryItem from './MetricCategoryItem'

/**
 * @const
 * @enum {string}
 */
const MetricItemGroup = {
  CONTENT: 'Content',
  ENGAGEMENTS: 'Engagements',
  AUTHORS: 'Authors',
  RATINGS_SCORES: 'RatingsScores'
}

const MetricItem = Object.freeze({
  CHILDREN_OPE: [MetricCategoryItem.OWNED, MetricCategoryItem.PARTNERED, MetricCategoryItem.EARNED],
  CHILDREN_CHANNELS: [
    MetricCategoryItem.TWITTER,
    MetricCategoryItem.FACEBOOK,
    MetricCategoryItem.INSTAGRAM,
    MetricCategoryItem.YOU_TUBE,
    MetricCategoryItem.TIKTOK,
    MetricCategoryItem.OTHER
  ],
  CHILDREN_MENTIONS: [
    MetricCategoryItem.POSITIVES,
    MetricCategoryItem.NEGATIVES,
    MetricCategoryItem.NEUTRALS
  ],
  CHILDREN_POSTS: [MeasureType.POST_VIDEOS, MeasureType.POST_IMAGES, MeasureType.POST_OTHER],
  CHILDREN_NET_SENTIMENT: [MeasureType.POSITIVES, MeasureType.NEGATIVES],
  CHILDREN_AUTHORS: [
    MetricCategoryItem.MALE,
    MetricCategoryItem.FEMALE,
    MetricCategoryItem.UNKNOWN
  ],
  CHILDREN_ENGAGEMENTS: [
    MeasureType.COMMENTS,
    MeasureType.LIKES,
    MeasureType.SHARES,
    MeasureType.DISLIKES,
    MeasureType.VIEWS,
    MeasureType.SCORE
  ],
  CHILDREN_STAR_RATING: [
    MetricCategoryItem.FIVE_STAR,
    MetricCategoryItem.FOUR_STAR,
    MetricCategoryItem.THREE_STAR,
    MetricCategoryItem.TWO_STAR,
    MetricCategoryItem.ONE_STAR,
    MetricCategoryItem.NO_RESPONSE_STAR
  ],
  CHILDREN_SURVEY_SCORE: [
    MetricCategoryItem.TEN_SCORE,
    MetricCategoryItem.HIGH_SCORE,
    MetricCategoryItem.MEDIUM_SCORE,
    MetricCategoryItem.LOW_SCORE,
    MetricCategoryItem.NO_SCORE,
    MetricCategoryItem.NO_RESPONSE_SURVEY
  ],
  CHILDREN_SURVEY_SCORE_DISPLAY: [
    MetricCategoryItem.TEN_SCORE,
    MetricCategoryItem.HIGH_SCORE,
    MetricCategoryItem.MEDIUM_SCORE,
    MetricCategoryItem.LOW_SCORE,
    MetricCategoryItem.NO_SCORE,
    MetricCategoryItem.NO_RESPONSE_SURVEY
  ],
  CHILDREN_NET_PROMOTER_SCORE: [
    MetricCategoryItem.PROMOTER,
    MetricCategoryItem.PASSIVE,
    MetricCategoryItem.DETRACTOR,
    MetricCategoryItem.NO_RESPONSE_NPS
  ],
  ALL_PARENT_TYPES: [
    MeasureType.MENTIONS,
    MeasureType.POSTS,
    MeasureType.NET_SENTIMENT,
    MeasureType.POSITIVES,
    MeasureType.NEGATIVES,
    MeasureType.PASSION_INTENSITY,
    MeasureType.ENGAGEMENTS,
    MeasureType.COMMENTS,
    MeasureType.LIKES,
    MeasureType.SHARES,
    MeasureType.VIEWS,
    MeasureType.DISLIKES,
    MeasureType.SCORE,
    MeasureType.ENGAGEMENT_RATIO,
    MeasureType.IMPRESSIONS,
    MeasureType.UNIQUE_AUTHORS,
    MeasureType.OVERALL_STAR_RATINGS,
    MeasureType.OVERALL_SURVEY_SCORES,
    MeasureType.NET_PROMOTER_SCORES,
    MeasureType.STAR_RATINGS,
    MeasureType.SURVEY_SCORES
  ]
})

export { MetricItem, MetricItemGroup }
